import { useCallback, useEffect, useRef } from "react";
import useAuthUser from "./useAuthUser";
import emitter, { EVENTS } from "lib/emitter";
import { isDesktop, initDesktopNotifications, setDockBadge } from "../desktop";

export default function useDesktopPush() {
  const { user } = useAuthUser();
  const registeredRef = useRef(false);

  const registerPush = useCallback(async () => {
    if (!isDesktop || !user || registeredRef.current) return;

    try {
      await initDesktopNotifications({
        onNotificationTapped: (chatId) => {
          window.location.href = `/messages/${chatId}`;
        },
      });
      registeredRef.current = true;
      console.log("[DesktopPush] Initialized");
    } catch (e) {
      console.error("[DesktopPush] Init failed:", e);
    }
  }, [user]);

  const cleanup = useCallback(() => {
    registeredRef.current = false;
    setDockBadge(0);
  }, []);

  useEffect(() => {
    if (user && isDesktop) {
      registerPush();
    }
  }, [user, registerPush]);

  useEffect(() => {
    const onLoginDataChange = (data: any) => {
      if (!data?.user) cleanup();
    };
    emitter.on(EVENTS.SET_LOGIN_DATA, onLoginDataChange);
    return () => {
      emitter.off(EVENTS.SET_LOGIN_DATA, onLoginDataChange);
    };
  }, [cleanup]);
}
